import { useContext } from "react";
import { AppContext } from "../App";
import { RiHome6Line } from "react-icons/ri";
import { MdAddLocationAlt, MdDirectionsCar } from "react-icons/md";
import { FaRegUser } from "react-icons/fa";
import {STR_REQUEST_RIDE} from "../Strings";
import { LiaUserSolid } from "react-icons/lia";

export default function BottomBar() {
  const appContext = useContext(AppContext);

  return (
    <div className="BottomBar">
      <div className="barInner">

        {/* Home */}
        <div
          className="mIcon"
          data-active={appContext.navItem === 'request_ride' || !appContext.navItem}
          onClick={() => appContext.navTo({ item: 'request_ride' })}
        >
          <MdAddLocationAlt className="mSymbol" />
          <div className="mText">{STR_REQUEST_RIDE[appContext.language]}</div>
        </div>

        {/* My Rides */}
        <div
          className="mIcon"
          data-active={appContext.navItem === 'my_rides'}
          onClick={() => appContext.navTo({ item: 'my_rides' })}
        >
          <MdDirectionsCar className="mSymbol" />
          <div className="mText">My Rides</div>
        </div>

        {/* My Account */}
        <div
          className="mIcon"
          data-active={appContext.navItem === 'account'}
          onClick={() => appContext.navTo({ item: 'account' })}
        >
          <LiaUserSolid className="mSymbol" />
          <div className="mText">Account</div>
        </div>

      </div>
    </div>
  );
}